import { MainNavProps } from "../navigation/main/MainParamList";
import BaseScreen from "../BaseScreen";
import {
  color_333333,
  color_666666,
  color_999999,
  color_BEBEBE,
  color_E43737,
  color_EDEEF1,
  color_main,
  white,
} from "../../assets/style/colors";
import NavBar from "../../components/NavBar";
import {
  Str_AddAccount,
  Str_AuthorizeHadExpired,
  Str_Cancel,
  Str_Clear,
  Str_Confirm,
  Str_InviteCode,
  Str_Manage,
  Str_NowUse,
  Str_SwitchAccount,
  Str_SwitchAccSuc,
  Str_SwitchAccTip,
} from "../../language/string_res";
import * as ImSdk from "../../../imsdk/api";
import { useEffect, useRef, useState } from "react";
import { KKAuth } from "../../../imsdk/api";
import { FlatList, Platform, Pressable, Text, View } from "react-native";
import { LeftView } from "../Chat/CListItem";
import { hideLoading, showLoading } from "../../components/Loading";
import log from "../../../imsdk/log";
import {
  getVcode,
  setEncrypt,
  setMsgAssistant,
  setMsgTranslate,
  setSecret,
  setServiceUrl,
  setToken,
  setUid,
  setVcode,
} from "../../store/token";
import { useStore } from "../../store/UserStore";
import { GetContactList, qryContactBlackList } from "../../store/utils";
import { ButtonView } from "../../components/ButtonView";
import { useAppNavigation } from "../navigation";
import { useTranslation } from "react-i18next";
import { Auth } from "../../../imsdk/db/t_auth";
import { showDialog } from "../../components/CommonDialog";
import { ErrorCodePermission } from "../../net/http";
import { showToast } from "../../components/Toast";
import { useSwitchAccStore } from "../../store/SwitchAccStore";
import { useChatDispatchOnly } from "../../store/ChatStore";
import { JPushManager } from "../../utils/JPushManager";
import cache from "../../cache";
import globalEventBus from "../../utils/EventBus";
import { ScreenCloseModal, ScreenModal } from "../../components/ScreenModal";
import { TenantSettings } from "../../../imsdk/db/t_user_devices";
import { setIgnoreAuthFail, setNotIgnoreAuthFail } from "../../../App";

type AccountData = KKAuth & Auth;
export const SwitchAccount = ({
  navigation,
}: MainNavProps<"SwitchAccount">) => {
  const appNavigation = useAppNavigation();
  const [auth, setAuth] = useState<AccountData[]>();
  const nowAcc = useRef<AccountData>();
  const [showDel, setShowDel] = useState(false);
  const [showManage, setManage] = useState(false);
  const im = ImSdk.getInstance();
  const uid = im.CurrentUid();
  const { dispatch } = useStore();
  const { switchDispatch } = useSwitchAccStore();
  const chatDispatch = useChatDispatchOnly();
  useTranslation();

  useEffect(() => {
    updateAuths()
  }, [])

  const updateAuths = () => {
    im.getAuths().then(r => {
      let auths = r.auths?.filter(v => v.uid && v.uid > 0);
      if (auths && auths.length > 0) {
        //fix bug:
        auths = moveCurrentToFirst(auths, uid)
        setAuth(auths)
        setManage(auths.length > 1)
        fetchUser(auths)
        nowAcc.current = auths.find(v => v.uid === uid)
      }
    })
  }

  const fetchUser = (auths: AccountData[]) => {
    const uids = auths.map((v) => v.uid);
    im.GetUsersRemote(uids).then((r1) => {
      const users = r1.users;
      if (users && users.length > 0) {
        const data = auths?.map((value) => {
          const index = users!.findIndex((v) => v.uid === value.uid);
          if (index >= 0) {
            const user = users![index];
            value.nick = user.nick;
            value.avatar = user.avatar;
          }
          return value;
        });
        setAuth(data);
        setManage(auths.length > 1);
      }
    });
  };

  // 当前uid放在首位
  const moveCurrentToFirst = (array: AccountData[], targetUid: number) => {
    // 创建数组副本，避免修改原数组
    const newArray = [...array];
    const targetIndex = newArray.findIndex((item) => item.uid === targetUid);

    if (targetIndex > 0) {
      // 找到目标元素并移动到第一个位置
      const [targetItem] = newArray.splice(targetIndex, 1);
      newArray.unshift(targetItem);
    }

    return newArray;
  };

  const SwitchUser = async (auth: AccountData, reset: Boolean = false) => {
    if (!auth.token || auth.token.length === 0 || !auth.uid || auth.uid === 0) {
      authExpired(auth)
      return;
    }
    try {
      await setIgnoreAuthFail();
      const r = await im.SwitchUser(auth);
      if (r.error) {
        authExpired(auth)
        return;
      }
      const rsp = await im.GetUserRemote(auth.uid);
      
      if (rsp.error && rsp.error.code !== ErrorCodePermission) {
      // 已经有1003处理了 - 这里只需要处理非1003的错误即可
        authExpired(auth)
        return;
      }
      if (
        rsp.users &&
        rsp.users.length > 0 &&
        rsp.users[0].uid === im.CurrentUid()
      ) {
        dispatch({
          type: "UPDATE_USER_INFO",
          payload: rsp.users[0] as any,
        });
        JPushManager.setAlias(auth.uid.toString());
        setVcode(auth.vcode);
        setServiceUrl(auth.customerServiceUrl);
        setUid(auth.uid);
        setToken(auth.token);
        setSecret(auth.secret);
        setEncrypt(auth.encrypt);
        setMsgAssistant(auth.msgAssistant);
        setMsgTranslate(auth.msgTranslate);

        hideLoading();
        //只有非切换才会执行下面的
        if (!reset) {
          switchDispatch("SWITCH_ACCOUNT");
          dispatch({
            type: "REPLACE_TOPIC_SUMMARY_LIST",
            payload: { top: [], normal: [] },
          });
          dispatch({
            type: "REPLACE_CONTACT_LIST",
            payload: { users: [], black: [] },
          });
          refreshFunc(auth.uid);
          refreshContact().then();
          refreshLoginDevices()
          refreshFriendApplyNum()

          const tenant_settings: TenantSettings = {
            switch_regist: auth.switch_regist ?? 0,
            switch_tab_main: auth.switch_tab_main ?? 0,
            switch_tab_mine: auth.switch_tab_mine ?? 1, // 至少开启一个
            switch_rtc: auth.switch_rtc ?? 0
          }
          dispatch({
            type: 'UPDATE_TENANT_SETTINGS',
            payload: tenant_settings
          });

          cache.Set("justSwitchedAccount", true);
          // 清空聊天侧状态（入群申请、当前会话等），避免上一账号残留在右栏/内存
          chatDispatch({ type: "CHAT_CLEAN" });
          if (Platform.OS === "web") {
            globalEventBus.emit("ClearWebDetail", {});
          }
          // showToast(Str_SwitchAccSuc)
          // 重新拉取TabBar是否配置了Web
          globalEventBus.emit("currentUserChanged", undefined);
          navigation.reset({ index: 0, routes: [{ name: "MainTab" }] });
          // 还原需要处理授权失败问题
          setNotIgnoreAuthFail();
        }
      } else {
        if (!reset) {
          authExpired(auth)
          // 还原需要处理授权失败问题
          setNotIgnoreAuthFail();
        } else {
          im.global_emit("global_logout", {
            global_logout: { vcode: auth.vcode },
          });
          // 还原需要处理授权失败问题
          setNotIgnoreAuthFail();
        }
      }
    } catch {
      if (!reset) {
        authExpired(auth)
        // 还原需要处理授权失败问题
        setNotIgnoreAuthFail();
      } else {
        im.global_emit("global_logout", {
          global_logout: { vcode: auth.vcode },
        });
        // 还原需要处理授权失败问题
        setNotIgnoreAuthFail();
      }
    }
  };

  const refreshFunc = (uid: number) => {
    // isEmit 固定 false：REPLACE 会整体替换列表，避免逐条 emit topic_qry（与 App.refreshFunc 对齐）
    im.GetAllTopicList(false, false).then((res) => {
      const { isAllRefresh, topTopics, normalTopics } = res;
      if (isAllRefresh) {
        const topicSummary = {
          top: topTopics || [],
          normal: normalTopics || [],
        };
        im.SetCache(`${uid}_topic_list`, topicSummary);
        dispatch({
          type: "REPLACE_TOPIC_SUMMARY_LIST",
          payload: topicSummary,
        });
      }
    });
  };

  function refreshLoginDevices() {
    im.updateLoginDevices().then(res => {
      if (res.error) {
        log.warn("更新登录设备列表失败", res.error);
      }
    });
  }

  const refreshFriendApplyNum = async () => {
    im.queryFriendApplyNum().then(res => {
      if (res.error) {
        log.warn("更新好友申请数量失败", res.error);
        return
      }
      // 更新到State
      dispatch({
        type: 'UPDATE_FRIEND_APPLY_NUM',
        payload: res.friendApplyNum || 0
      });
    });
  }

  async function refreshContact() {
    Promise.all([GetContactList(), qryContactBlackList()]).then((res) => {
      const contacts = res[0].contacts ?? [];
      const blacks = res[1].blacks ?? [];
      dispatch({
        type: "REPLACE_CONTACT_LIST",
        payload: { users: contacts, black: blacks },
      });
    });
    await ImSdk.getInstance().GetLabelsRemote(0, 10000);
  }

  const authExpired = (auth: AccountData) => {
    hideLoading()
    im.delAuths(auth.uid);
    updateAuths()
    showDialog({
      message: Str_AuthorizeHadExpired,
      confirmText: Str_Confirm,
      cancelText: Str_Cancel,
      onCancel: () => {
      },
      onConfirm: () => {
        gotoAddAccount()
      },
    })
    log.warn("切换用户失败:", auth);
  }


  const ItemClick = (item: AccountData) => {
    if (item?.uid === uid) return;
    showLoading("");
    SwitchUser(item);
  };
  const ItemDelClick = (item: AccountData) => {
    if (item?.uid && item?.uid === uid) return;
    showLoading("");
    im.delAuths(item?.uid).then((r) => {
      // im.delAuths(uid, item?.uid,).then(r => {
      hideLoading();
      setAuth((prevState) => {
        return prevState?.filter((value) => value?.uid !== item?.uid);
      });
    });
  };
  const renderItem = ({ item }: { item: AccountData }) => {
    return (
      <Pressable
        style={{
          backgroundColor: white,
          marginTop: 10,
          borderRadius: 6,
          marginHorizontal: 16,
          paddingHorizontal: 10,
          paddingVertical: 10,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
        }}
        onPress={() => {
          if (!showDel) ItemClick(item);
        }}
      >
        <LeftView
          left={{ avatar: item?.avatar, name: item?.nick, uid: item?.uid || 0 }}
          size={50}
          isRounded={true}
          isGroup={false}
          radius={4}
        />
        <View
          style={{
            flex: 1,
            justifyContent: "center",
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Text
              numberOfLines={1}
              ellipsizeMode={"tail"}
              style={{
                color: color_333333,
                fontSize: 16,
                fontWeight: "bold",
                flex: 1,
                fontFamily: "",
              }}
            >
              {item?.nick}
            </Text>
            {uid === item?.uid && (
              <Text
                style={{
                  color: color_main,
                  fontSize: 12,
                }}
              >
                {Str_NowUse}
              </Text>
            )}
          </View>
          <View
            style={{
              flexDirection: "row",
              marginTop: 4,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Text
              numberOfLines={1}
              ellipsizeMode={"tail"}
              style={{
                color: color_999999,
                fontSize: 12,
              }}
            >
              {item?.account || item?.phone}
            </Text>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Text
                numberOfLines={1}
                ellipsizeMode={"tail"}
                style={{
                  color: color_333333,
                  fontSize: 12,
                }}
              >
                {Str_InviteCode}：
              </Text>
              <View
                style={{
                  backgroundColor: color_main,
                  borderRadius: 14,
                  paddingHorizontal: 6,
                  alignSelf: "flex-start", // 避免撑满父容器
                }}
              >
                <Text
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  style={{
                    color: white,
                    fontSize: 12,
                    textAlign: "center",
                  }}
                >
                  {item?.vcode}
                </Text>
              </View>
            </View>
          </View>
        </View>
        {showDel && uid !== item?.uid && (
          <ButtonView
            style={{
              backgroundColor: color_E43737,
              paddingHorizontal: 16,
              borderRadius: 4,
              alignItems: "center",
              height: 32,
              marginStart: 10,
              justifyContent: "center",
            }}
            onPress={() => ItemDelClick(item)}
            textStyle={{
              color: white,
              fontSize: 14,
              fontWeight: "bold",
              fontFamily: "",
            }}
            text={Str_Clear}
          />
        )}
      </Pressable>
    );
  };

  const gotoAddAccount = () => {
    appNavigation.navigate('AuthStack', {
      // screen: "Login",
      vcode: getVcode(), isAddAccount: true, lastUid: uid//当前的用id
    })
  }

  const ListFooterComponent = () => {
    return (
      <Pressable
        onPress={gotoAddAccount}
        style={{
          backgroundColor: white,
          marginTop: 10,
          borderRadius: 6,
          marginHorizontal: 16,
          paddingHorizontal: 10,
          paddingVertical: 10,
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        <View
          style={{
            height: 50,
            width: 50,
            borderRadius: 4,
            borderWidth: 0.5,
            borderColor: color_BEBEBE,
          }}
        >
          <View
            style={{
              position: "absolute",
              start: 25,
              end: 0,
              top: 14,
              bottom: 14,
              width: 1,
              backgroundColor: color_999999,
            }}
          />
          <View
            style={{
              position: "absolute",
              start: 14,
              end: 14,
              top: 25,
              bottom: 0,
              height: 0.5,
              backgroundColor: color_999999,
            }}
          />
        </View>
        <Text
          numberOfLines={1}
          ellipsizeMode={"tail"}
          style={{
            color: color_666666,
            fontSize: 16,
            marginStart: 12,
            flex: 1,
            fontFamily: "",
          }}
        >
          {Str_AddAccount}
        </Text>
      </Pressable>
    );
  };
  return (
    <ScreenCloseModal title={Str_SwitchAccount}>
      {/* <NavBar ... /> */}
      <FlatList
        style={{ marginTop: 8 }}
        data={auth}
        keyExtractor={(item, index) => index.toString()}
        ListFooterComponent={ListFooterComponent}
        renderItem={renderItem}
      />
    </ScreenCloseModal>
  );
};
